import { createApiAction } from 'src/api';

export const FETCH_FORM_DATA_START = 'account/fetch_form_data_start';
export const FETCH_FORM_DATA_SUCCESS = 'account/fetch_form_data_success';
export const FETCH_FORM_DATA_FAILURE = 'account/fetch_form_data_failure';

export const fetchFormData = (financialInstitutionId, accountId) =>
  createApiAction(
    {
      path: financialInstitutionId
        ? `/api/v1/fis/${financialInstitutionId}/form_data/${
            accountId ? `?account_id=${accountId}` : ''
          }`
        : `/api/v1/form_data/${accountId ? `?account_id=${accountId}` : ''}`,
    },
    [FETCH_FORM_DATA_START, FETCH_FORM_DATA_SUCCESS, FETCH_FORM_DATA_FAILURE]
  );
